import { theme } from '@citygross/design-tokens';
import { EButtonSize, EButtonVariant } from '../components/CgButton/CgButton.types.js';

var getButtonSizeAttributes = function getButtonSizeAttributes(buttonSize) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;

  switch (buttonSize) {
    case EButtonSize.small:
      return {
        fontSize: (_b = (_a = theme.typography) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.s2,
        height: (_c = theme.spacings) === null || _c === void 0 ? void 0 : _c.lg,
        loadingSpinner: (_d = theme.spacings) === null || _d === void 0 ? void 0 : _d.xs3,
        paddingX: (_e = theme.spacings) === null || _e === void 0 ? void 0 : _e.xs,
        paddingY: (_f = theme.spacings) === null || _f === void 0 ? void 0 : _f.xxs
      };

    case EButtonSize.medium:
      return {
        fontSize: (_h = (_g = theme.typography) === null || _g === void 0 ? void 0 : _g.size) === null || _h === void 0 ? void 0 : _h.s3,
        height: (_j = theme.spacings) === null || _j === void 0 ? void 0 : _j.xl,
        loadingSpinner: (_k = theme.spacings) === null || _k === void 0 ? void 0 : _k.sm,
        paddingX: (_l = theme.spacings) === null || _l === void 0 ? void 0 : _l.xs2,
        paddingY: (_m = theme.spacings) === null || _m === void 0 ? void 0 : _m.xs
      };

    case EButtonSize.large:
      return {
        fontSize: (_p = (_o = theme.typography) === null || _o === void 0 ? void 0 : _o.size) === null || _p === void 0 ? void 0 : _p.s3,
        height: (_q = theme.spacings) === null || _q === void 0 ? void 0 : _q.xl2,
        loadingSpinner: (_r = theme.spacings) === null || _r === void 0 ? void 0 : _r.sm2,
        paddingX: (_s = theme.spacings) === null || _s === void 0 ? void 0 : _s.sm,
        paddingY: (_t = theme.spacings) === null || _t === void 0 ? void 0 : _t.xs2
      };

    default:
      return {};
  }
};

var getButtonVariantAttributes = function getButtonVariantAttributes(buttonVariant) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;

  switch (buttonVariant) {
    case EButtonVariant.primary:
      return {
        backgroundActive: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlueActive,
        backgroundColor: (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.brandBlue,
        backgroundDisabled: (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.light,
        backgroundHover: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.brandBlueHover,
        fontColor: (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.white
      };

    case EButtonVariant.secondary:
      return {
        backgroundActive: (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.lighter,
        backgroundColor: (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.white,
        backgroundDisabled: (_h = theme.palette) === null || _h === void 0 ? void 0 : _h.white,
        backgroundHover: (_j = theme.palette) === null || _j === void 0 ? void 0 : _j.lightest,
        border: true,
        fontColor: (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.darkest
      };

    case EButtonVariant.tertiary:
      return {
        backgroundActive: (_l = theme.palette) === null || _l === void 0 ? void 0 : _l.brandYellowActive,
        backgroundColor: (_m = theme.palette) === null || _m === void 0 ? void 0 : _m.brandYellow,
        backgroundDisabled: (_o = theme.palette) === null || _o === void 0 ? void 0 : _o.light,
        backgroundHover: (_p = theme.palette) === null || _p === void 0 ? void 0 : _p.brandYellowHover,
        fontColor: (_q = theme.palette) === null || _q === void 0 ? void 0 : _q.darkest
      };

    case EButtonVariant.prio:
      return {
        backgroundActive: (_r = theme.palette) === null || _r === void 0 ? void 0 : _r.brandPrioActive,
        backgroundColor: (_s = theme.palette) === null || _s === void 0 ? void 0 : _s.brandPurple,
        backgroundDisabled: (_t = theme.palette) === null || _t === void 0 ? void 0 : _t.light,
        backgroundHover: (_u = theme.palette) === null || _u === void 0 ? void 0 : _u.brandPrioHover,
        fontColor: (_v = theme.palette) === null || _v === void 0 ? void 0 : _v.white
      };

    case EButtonVariant.ghost:
      return {
        backgroundActive: (_w = theme.palette) === null || _w === void 0 ? void 0 : _w.lighter,
        backgroundColor: (_x = theme.palette) === null || _x === void 0 ? void 0 : _x.white,
        backgroundDisabled: (_y = theme.palette) === null || _y === void 0 ? void 0 : _y.white,
        backgroundHover: (_z = theme.palette) === null || _z === void 0 ? void 0 : _z.lightest,
        fontColor: (_0 = theme.palette) === null || _0 === void 0 ? void 0 : _0.darkest
      };

    default:
      return {};
  }
};

var getButtonAttributes = function getButtonAttributes(buttonSize, buttonVariant) {
  return {
    sizeAttributes: getButtonSizeAttributes(buttonSize),
    variantAttributes: getButtonVariantAttributes(buttonVariant)
  };
};

export { getButtonAttributes };